import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const DiscoverView = styled.section`
	flex: 1 1 auto;
	min-height: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	min-width: 0;
	width: 100%;
	max-width: 100%;

	@media (max-width: ${THEME.mobileBreakpoint}) {
		position: fixed;
		inset: 0;
		z-index: 20;
		background: #050507;
	}
`;

export const DiscoverShell = styled.div`
	position: relative;
	flex: 1 1 auto;
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 18px;
	overflow-y: auto;
	scroll-snap-type: y mandatory;
	scroll-behavior: smooth;
	scrollbar-width: none;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior-y: contain;

	&::-webkit-scrollbar {
		display: none;
	}

	@media (max-width: ${THEME.mobileBreakpoint}) {
		height: 100%;
		padding: 0;
	}
`;

export const DiscoverFeedScroll = styled.div`
	width: min(480px, 100%);

	@media (max-width: ${THEME.mobileBreakpoint}) {
		width: 100%;
	}
`;

export const DiscoverFeedItem = styled.div`
	width: 100%;
	scroll-snap-align: start;
	scroll-snap-stop: always;
`;
